import { Component, inject } from '@angular/core';
import { AuthService } from 'src/services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export class LoginComponent {
    private authService = inject(AuthService);

    public login(): void {
        this.authService.login();
    }
}
